<template>
  <div v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-body">
            <div class="box-group" id="accordion">
              <div class="panel box box-primary">
                <div class="box-header with-border">
                  <h4 class="box-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseHelpTransfer" aria-expanded="false"
                       class="collapsed">
                      {{$t('help.title')}}
                    </a>
                  </h4>
                </div>
                <div id="collapseHelpTransfer" class="panel-collapse collapse" aria-expanded="false"
                     style="height: 0px;">
                  <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                    <p>If you offer a transfer of the participant from the airport (train station, other) to the
                      sports camp location (vice-versa) for an additional fee, - type here the option (s) and its
                      respective price. If such a service is not applicable - leave the field blank.</p>

                    <p>Example:
                      <br>(a) Transfer from the London Heathrow airport to the "Academy" - 50 GBP;
                      <br>(b) Transfer from the "Academy" to the London Heathrow airport - 50 GBP</p>

                  </div>
                  <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                    <p>Если трансфер спортсмена от аэропорта (вокзала, иное) не входит в цену программы и
                      оплачивается отдельно, - то укажите наименование и цену за услугу. Если такая услугу не
                      предлагается в принципе - оставьте поле пустым.</p>

                    <p>Пример:
                      <br>(а) Трансфер от аэропорта Внуково (Москва) до Академии - 1000 руб.
                      <br>(б) Трансфер от Академии до аэропорта Внуково (Москва) - 1000 руб.</p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.transfers.active-transfers')}}</h3>
          </div>
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <tbody>
              <tr>
                <th>{{$t('trainings.transfers.name')}}</th>
                <th v-if="isBackoffice()">{{$t('trainings.transfers.name')}} [ru]</th>
                <th>{{$t('trainings.transfers.price')}}</th>
                <th></th>
              </tr>
              <tr
                v-for="transfer in currentTraining.transfers"
                :key="transfer.id">
                <td v-if="!isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="transfer.name[$root.$i18n.locale]" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateTransfer(transfer)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="transfer.name['en']" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateTransfer(transfer)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="transfer.name['ru']" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateTransfer(transfer)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td>{{transfer.price.value}} {{transfer.price.currency.codeISO}}</td>
                <td><a v-on:click="deleteTransfer(transfer.id)"><i class="text-red fa fa-times-circle-o"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.transfers.added-form.title')}}</h3>
          </div>
          <div class="box-body">
            <div v-if="!isBackoffice()" class="form-group">
              <label>{{$t('trainings.transfers.added-form.name')}}</label>
              <input type="text" v-model="addedTransfer.name[$root.$i18n.locale]" class="form-control" placeholder="">
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.transfers.added-form.name')}} [en]</label>
              <input type="text" v-model="addedTransfer.name['en']" class="form-control" placeholder="">
            </div>
            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.transfers.added-form.name')}} [ru]</label>
              <input type="text" v-model="addedTransfer.name['ru']" class="form-control" placeholder="">
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label>{{$t('trainings.transfers.added-form.price')}}</label>
                    <input type="text" class="form-control" v-model="addedTransfer.price.value" placeholder="">
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label>{{$t('trainings.transfers.added-form.currency')}}</label>
                    <select name="currency" class="form-control" v-model="addedTransfer.price.currency">
                      <option value="RUB">RUB</option>
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                      <option value="GBP">GBP</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <button type="submit" v-on:click="saveTransfer" class="btn btn-info pull-right">
              {{$t('button.save-changes')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrainingTransfers',
  props: {
    currentTraining: Object
  },
  data () {
    return {
      addedTransfer: {
        trainingId: '',
        name: {
          ru: '',
          en: ''
        },
        price: {
          value: 0,
          currency: ''
        },
        description: {
          ru: '',
          en: ''
        }
      }
    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    deleteTransfer (transferId) {
      var del = {
        transferId: transferId,
        trainingId: this.currentTraining.id
      };

      var self = this;

      console.log(del);

      axios.delete(
        //window.rootRoute + '/api/trainings/transfers', {data: {transfer: del}})
      window.host + '/trainings/' + self.currentTraining.id + '/transfers/' + transferId, del)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', del.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    saveTransfer () {
      var self = this;

      self.addedTransfer.trainingId = self.currentTraining.id;

      axios.put(
        window.host + '/trainings/' + self.currentTraining.id + '/transfers', self.addedTransfer)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.addedTransfer.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    updateTransfer (transfer) {
      var self = this;

      transfer.trainingId = self.currentTraining.id;

      var savedTransfer = {
        transferId: transfer.id,
        trainingId: self.currentTraining.id,
        price: {
          value: transfer.price.value,
          currency: transfer.price.currency.codeISO
        },
        name: transfer.name,
        description: transfer.description,
      };

      axios.put(
        window.host + '/trainings/' + self.currentTraining.id + '/transfers/update', savedTransfer)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
